export const VERIFY_EMAIL_RESPONSE_TYPE = {
  VERIFICATION_EMAIL_SENT: 'VERIFICATION_EMAIL_SENT',
  NO_VERIFICATION_REQUIRED: 'NO_VERIFICATION_REQUIRED',
  SUCCESSFULLY_DELETED: 'SUCCESSFULLY_DELETED',
} as const;

type ObjectValues<T> = T[keyof T];

export type VerifyEmailResponseType = ObjectValues<typeof VERIFY_EMAIL_RESPONSE_TYPE>;
